<template>

    <div class="ad_product-login">

        <h3 class="title-4">Connectez-vous</h3>
        <p class="subtitle-5">pour commander en quelques clics</p>

        <a 
            class="button button--product-login"
            href="#"
            v-on:click="showLoginModale"
            v-if="ready && !isAuth">

            <i class="fa fa-user"></i>
            <span class="ad_menu-item__label">Se connecter | S'inscrire</span>

        </a>

    </div>

</template>

<script>

import Login from './Login.vue'

export default {

    mixins: [ Login ],
    name: 'LoginLink'
}
</script>

<style>


/* Woocommerce override */

.woocommerce .button.button--product-login {
    width: 100%;
}

.ad_product-login {
    margin: 2rem 0;
}

</style>
